/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WizardFilterOptionDto } from './WizardFilterOptionDto';
import {
    WizardFilterOptionDtoFromJSON,
    WizardFilterOptionDtoFromJSONTyped,
    WizardFilterOptionDtoToJSON,
    WizardFilterOptionDtoToJSONTyped,
} from './WizardFilterOptionDto';

/**
 * 
 * @export
 * @interface ListWizardFilterOptionsResponseDto
 */
export interface ListWizardFilterOptionsResponseDto {
    /**
     * 
     * @type {Array<WizardFilterOptionDto>}
     * @memberof ListWizardFilterOptionsResponseDto
     */
    data: Array<WizardFilterOptionDto>;
}

/**
 * Check if a given object implements the ListWizardFilterOptionsResponseDto interface.
 */
export function instanceOfListWizardFilterOptionsResponseDto(value: object): value is ListWizardFilterOptionsResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ListWizardFilterOptionsResponseDtoFromJSON(json: any): ListWizardFilterOptionsResponseDto {
    return ListWizardFilterOptionsResponseDtoFromJSONTyped(json, false);
}

export function ListWizardFilterOptionsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListWizardFilterOptionsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(WizardFilterOptionDtoFromJSON)),
    };
}

export function ListWizardFilterOptionsResponseDtoToJSON(json: any): ListWizardFilterOptionsResponseDto {
    return ListWizardFilterOptionsResponseDtoToJSONTyped(json, false);
}

export function ListWizardFilterOptionsResponseDtoToJSONTyped(value?: ListWizardFilterOptionsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(WizardFilterOptionDtoToJSON)),
    };
}

